import React from 'react';
import { Stack, Typography, Button } from '@mui/material';
import { AddRounded } from '@mui/icons-material';
import { useTheme } from '@mui/system';

function AddItemPanel({ setIsEditing }) {
    const theme = useTheme();
    // In this case, the item in question is not on the physician's draft, but is on a peer's draft.
    // We want to show not on card, and have an add to my card button, which will add it to the physician's draft.

    return (
        <Stack p={2} spacing={2} direction='column' backgroundColor={theme.palette.background.white} borderRadius={1}>
            <Typography variant='bold' >My Card</Typography>
            <Stack direction='row' alignItems='center' justifyContent='space-between'>
                <Typography variant='normal' sx={{ fontSize: '14px', backgroundColor: theme.palette.background.categoryDrawer, p:0.5, borderRadius: 1 }}>Not On Card</Typography>
                <Button variant='outlined' color='primary' startIcon={<AddRounded />} onClick={() => setIsEditing(true)}>Add to My Card</Button>
            </Stack>
        </Stack>
    )

}

export default AddItemPanel;